<template>
  <div class="btn-arrow-container">
    <span class="text">{{text}}</span>
    <svg version="1.1" :class="{'right': right}" id="Calque_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 1605 508.06" enable-background="new 0 0 1605 508.06" xml:space="preserve">
      <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="0" y1="254.0288" x2="1605" y2="254.0288">
        <stop  offset="0" style="stop-color: #FBEA00"/>
        <stop  offset="1" style="stop-color: #F77100"/>
      </linearGradient>
      <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="0" y1="254.0288" x2="1605" y2="254.0288">
        <stop  offset="0" style="stop-color: rgb(248, 192, 67)"/>
        <stop  offset="0.5" style="stop-color: rgb(246, 145, 67)"/>
        <stop  offset="1" style="stop-color: #EE4140"/>
      </linearGradient>
      <polygon fill="url(#SVGID_1_)" points="184.75,0 1605,0 1431.8,242.48 1605,508.06 184.75,508.06 0,254.03 "/>
      <polygon id="polygon" fill="url(#SVGID_2_)" points="184.75,0 1605,0 1431.8,242.48 1605,508.06 184.75,508.06 0,254.03 "/>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    direction: String
  },
  computed: {
    right() {
      return this.direction === 'right';
    }
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="sass" scoped>
.btn-arrow-container 
  width: 150px
  position: relative
  #polygon 
    cursor: pointer
    opacity: 0
    transition: all ease .5s
  #polygon:hover, .text:hover + svg #polygon
    opacity: 1

  .text
    cursor: pointer
    color: black
    position: absolute
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    font-size: 1.2rem
    text-transform: uppercase
    white-space: nowrap
    z-index: 1
  svg.right 
    transform: rotate(180deg)

</style>
